import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { BookingSubscription, BOOKING_SUBSCRIPTIONS_FILTER_TYPE } from '@store';

@Component({
  selector: 'app-booking-subscription-list',
  templateUrl: './booking-subscription-list.component.html',
  styleUrls: ['./booking-subscription-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingSubscriptionListComponent implements OnChanges {
  readonly filterType = BOOKING_SUBSCRIPTIONS_FILTER_TYPE;
  readonly paginatorPageSizeSmall = 6;
  readonly paginatorPageSizeBig = 12;
  readonly smallScreenSizeBreakPoint = 576;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Input() activeSubscriptionsFilter: BOOKING_SUBSCRIPTIONS_FILTER_TYPE;
  @Input() subscriptions: BookingSubscription[] = [];
  @Input() searchTerm: string;
  displayedSubscriptions: BookingSubscription[];
  pagination = {
    page: 0,
    pageSize:
      window.innerWidth < this.smallScreenSizeBreakPoint
        ? this.paginatorPageSizeSmall
        : this.paginatorPageSizeBig,
  };

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (
      window.innerWidth < this.smallScreenSizeBreakPoint &&
      this.pagination.pageSize === this.paginatorPageSizeBig
    ) {
      this.pagination.pageSize = this.paginatorPageSizeSmall;
      this.onPageChange();
    } else if (
      window.innerWidth >= this.smallScreenSizeBreakPoint &&
      this.pagination.pageSize === this.paginatorPageSizeSmall
    ) {
      this.pagination.pageSize = this.paginatorPageSizeBig;
      this.onPageChange();
    }
  }

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.subscriptions) {
      this.displayedSubscriptions = this.subscriptions.slice(0, this.pagination.pageSize);
    }
  }

  onPageChange(paginator?: PageEvent): void {
    const pageSize = this.pagination.pageSize;
    const firstElementIndex = paginator ? paginator.pageIndex * pageSize : 0;

    this.pagination.page = paginator ? paginator.pageIndex : 0;
    this.displayedSubscriptions = this.subscriptions.slice(
      firstElementIndex,
      firstElementIndex + pageSize
    );
  }
}
